// ****** JS FOR TEACHER TRANNING BUTTON *********

$(document).ready(function () {

  let cardCache = [];
  function buildCardCache() {
    cardCache = [];
    const $buttonWrap = $('.collection-tab-btn');
    if (!$buttonWrap.length) return;
    const buttonOffset = $buttonWrap.offset().top;
    $('.custom-product-card').each(function () {
      const rect = this.getBoundingClientRect();
      const top = rect.top + window.pageYOffset;
      if (top > buttonOffset) {
        cardCache.push({
          el: this,
          title: $(this).find('.custom-product-title').text().toLowerCase(),
          top: top
        });
      }
    });
  }
  requestAnimationFrame(() => {
    setTimeout(buildCardCache, 150);
  });
  $(window).on('load resize', function () {
    buildCardCache();
  });
  $('.coll-btn-link').on('click', function (e) {
    e.preventDefault();
    $('html, body').stop(true, true);
    const key = $.trim($(this).text()).toLowerCase();
    if (!key || !cardCache.length) return;

    const match = cardCache.find(card =>
      card.title.indexOf(key) !== -1
    );
    if (match) {
      window.scrollTo({
        top: match.top - 100,
        behavior: 'smooth'
      });
    }
  });

  $('.journey-mastery-section__tab-btn').on('click', function () {
    var $this = $(this);
    var targetId = $this.attr('aria-controls');
    var $section = $this.closest('.journey-mastery-section');

    // Deactivate all in this section
    $section.find('.journey-mastery-section__tab-btn').removeClass('is-active').attr('aria-selected', 'false');
    $section.find('.journey-mastery-section__tab-panel').removeClass('is-active').attr('hidden', true).hide();

    // Activate clicked
    $this.addClass('is-active').attr('aria-selected', 'true');
    $('#' + targetId).addClass('is-active').removeAttr('hidden').show();
  });
  
});

document.addEventListener('DOMContentLoaded', function () {

  const MOBILE_BREAKPOINT = 989;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  /* ---------------- ACTIVE TAB COLOR (MOBILE & DESKTOP) ---------------- */

  function initTabClicks() {
    const tabs = document.querySelectorAll('.sidebar-link');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function (e) {
        // Remove active from all tabs
        tabs.forEach(t => t.classList.remove('active'));
        
        // Add active to clicked tab
        this.classList.add('active');
      });
    });
  }

  function setDefaultActive() {
    const links = document.querySelectorAll('.sidebar-link');
    if (!links.length) return;

    links.forEach(l => l.classList.remove('active'));
    links[0].classList.add('active');
  }

  /* ---------------- MAKE ALL SECTIONS VISIBLE ---------------- */

  function showAllSections() {
    document
      .querySelectorAll('.custom-products-container')
      .forEach(s => s.classList.add('active'));
  }

  /* ---------------- INIT ---------------- */

  setTimeout(() => {
    initTabClicks();
    setDefaultActive();
    showAllSections();
  }, 150);

  /* ---------------- RESIZE HANDLING ---------------- */

  window.addEventListener('resize', function () {
    showAllSections();
  });
});



// ******JS FOR PRODUCT TAB SLIDER FIRST TAB *********

document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const swipers = new Map();
  const DESKTOP_MIN_SLIDES = 4; // > 3 slides only

  function shouldEnableDesktop(slider) {
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;
    return slidesCount >= DESKTOP_MIN_SLIDES;
  }

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function initSwipers() {
    document.querySelectorAll('.product-tab-swiper-slider[data-swiper]').forEach(slider => {

      if (!slider.offsetParent) return;

      const enableDesktop = shouldEnableDesktop(slider);

      // ----- Desktop: slides <= 3 → destroy swiper -----
      if (isDesktop() && !enableDesktop) {
        if (swipers.has(slider)) {
          swipers.get(slider).destroy(true, true);
          swipers.delete(slider);
        }
        return;
      }

      // ----- Already initialized → update only -----
      if (swipers.has(slider)) {
        const s = swipers.get(slider);
        s.update();
        s.updateSlides();
        s.updateSize();
        return;
      }

      // ----- INIT SWIPER -----
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 25,
        watchOverflow: true,
        resizeObserver: true,

        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },

        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: 1.2,   // Mobile always ON
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2.4,   // Tablet
          },
          1024: enableDesktop
            ? { slidesPerView: 3.4 } // Desktop ON only if slides > 3
            : { slidesPerView: 3 },  // Acts like static grid
            spaceBetween: 25,
        },

        on: {
          init() {
            requestAnimationFrame(() => {
              this.update();
              this.updateSlides();
              this.updateSize();
            });
          }
        }
      });

      swipers.set(slider, swiper);
    });
  }

  // Initial load
  initSwipers();

  // Tab click → re-evaluate
  document.addEventListener('click', e => {
    if (e.target.closest('[data-tab-trigger]')) {
      setTimeout(initSwipers, 150);
    }
  });

  // Resize → enable / disable dynamically
  window.addEventListener('resize', () => {
    initSwipers();
  });
});


// sticky collection bar exta space 

function scrollToTarget(link) {
  const targetSelector = link.getAttribute('href');
  const target = document.querySelector(targetSelector);

  if (!target) return;

  // header height + static extra offset
  const header = document.querySelector('header');
  const headerHeight = header ? header.offsetHeight : 55;
  const extraOffset = 50;
  const totalOffset = headerHeight + extraOffset;

  const targetPosition =
    target.getBoundingClientRect().top + window.pageYOffset - totalOffset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}

// CLICK
document.querySelectorAll('.prod-tab-slilder-title .sidebar-link')
  .forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToTarget(this);
    });
  });


// Product → landing page redirects (keep query string for UTM/discount params)
function redirectWithQuery(fromPath, toPath) {
  if (window.location.pathname !== fromPath) return;
  window.location.replace(toPath + window.location.search);
}

// Vietnam product PDP → Vietnam page (preserves query string)
redirectWithQuery(
  "/products/8-trigram-qigong-mastery-course-and-teacher-training-vietnam",
  "/pages/vietnam-8-trigram"
);

redirectWithQuery(
  "/products/8-trigram-qigong-master-course",
  "/pages/8-trigram-teacher-training"
);

redirectWithQuery(
  "/products/8-trigram-teacher-training",
  "/pages/8-trigram-teacher-training"
);

redirectWithQuery(
  "/products/bagua-circle-walking-retreat-8-trigram-qigong",
  "/pages/bagua-walking-retreat"
);